import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/addOns/catalog/view/license.addOn.grants.query.gql"
import type {
  AddOnGrantsQuery,
  AddOnGrantsQueryVariables,
} from "@/v2-backoffice-client/license/addOns/catalog/view/__types__/license.addOn.grants.query"

type Options = QueryHookOptions<AddOnGrantsQuery, AddOnGrantsQueryVariables>

export function useAddOnGrantsQuery(options?: Options) {
  return useQuery<AddOnGrantsQuery, AddOnGrantsQueryVariables>(query, options)
}
